<template>
  <span class="border-start">
    <div class="container-fluid">
      <div class="row g-0" style="width: 100vw">
        <span class="border-bottom">
          <h5>Review Details</h5>
        </span>
        <table class="table table-borderless">
          <tbody class="body">
            <tr>
              <td class="col-6 head">Transferring Agency</td>
              <td class="col-6"></td>
            </tr>
            <tr>
              <td class="content">
                {{ typesenseStore.currentContent?.transfer_agency }}
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="head">Item Title</td>
              <td class="head">Item ID</td>
            </tr>
            <tr>
              <td class="content">
                {{ typesenseStore.currentContent?.item_title }}
              </td>
              <td class="content">
                {{ typesenseStore.currentContent?.item_id }}
              </td>
            </tr>
            <tr v-if="typesenseStore.currentContent?.requester != null">
              <td class="head">Requester</td>
              <td class="head">Request Date</td>
            </tr>
            <tr v-if="typesenseStore.currentContent?.requester != null">
              <td class="content">
                {{ typesenseStore.currentContent?.requester }}
              </td>
              <td class="content">
                {{
                  $filters.formatUnixDateTime(
                    typesenseStore.currentContent?.requested_at
                  )
                }}
              </td>
            </tr>
            <tr v-if="typesenseStore.currentContent?.reviewer != null">
              <td class="head">Reviewer</td>
              <td class="head">Review Date</td>
            </tr>
            <tr v-if="typesenseStore.currentContent?.reviewer != null">
              <td class="content">
                {{ typesenseStore.currentContent?.reviewer }}
              </td>
              <td class="content">
                {{
                  $filters.formatUnixDateTime(
                    typesenseStore.currentContent?.reviewed_at
                  )
                }}
              </td>
            </tr>
            <tr
              v-if="
                typesenseStore.currentContent?.note &&
                (typesenseStore.currentContent?.status === 'Rejected' ||
                  typesenseStore.currentContent?.status === 'Cancelled')
              "
            >
              <td class="head">Note</td>
            </tr>
            <tr
              v-if="
                typesenseStore.currentContent?.note &&
                (typesenseStore.currentContent?.status === 'Rejected' ||
                  typesenseStore.currentContent?.status === 'Cancelled')
              "
            >
              <td class="content">
                {{ typesenseStore.currentContent?.note }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </span>
</template>

<script setup lang="ts">
import { useTypesenseStore } from "@/stores/typesense";

const typesenseStore = useTypesenseStore();
</script>

<style lang="scss" scoped>
.container-fluid {
  position: relative;
  float: left;
  display: flex;
  padding: 16px;
  max-width: 33.3vw;
  max-height: 90vh;
  margin-bottom: 50px;
  overflow: auto;
}
.table {
  margin-top: 16px;
}
</style>
